import type { LevelData } from '@/types';

const STAGE_WIDTH = 800;
const COIN_SIZE = 30;

const PLAYER_START: LevelData['playerStart'] = { x: 20, y: 518 };

// Battlefield-inspired fixed-screen arena:
// one main stage plus three upper platforms.
const PLATFORMS: LevelData['platforms'] = [
  { x: 0, y: 550, width: STAGE_WIDTH, height: 50 }, // floor at bottom (no empty gap)
  { x: 90, y: 430, width: 160, height: 18 },  // left upper
  { x: 320, y: 330, width: 160, height: 18 }, // center upper
  { x: 550, y: 430, width: 160, height: 18 }, // right upper
];

// Six cheese coins, mirrored and pulled toward center lanes to force contention.
const LEFT_COINS: LevelData['coins'] = [
  { x: 160, y: 500 },
  { x: 250, y: 340 },
  { x: 160, y: 90 }, // mirrored pair: jetpack-only and still below HUD band
];
const RIGHT_COINS: LevelData['coins'] = LEFT_COINS.map((coin) => ({
  x: STAGE_WIDTH - COIN_SIZE - coin.x,
  y: coin.y,
}));
const COINS: LevelData['coins'] = [...LEFT_COINS, ...RIGHT_COINS];

// Goal rocket is centered on the top middle platform.
const GOAL: LevelData['goal'] = { x: 384, y: 330 };

export const level1: LevelData = {
  id: 'level1',
  name: 'Lunar Launchpad',
  width: STAGE_WIDTH,
  height: 600,
  playerStart: PLAYER_START,
  platforms: PLATFORMS,
  coins: COINS,
  goal: GOAL,
};
